import { HttpClient, HttpHeaders } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import {
  InterceptorUtil,
  LoggerService,
  normalizeHttpError,
  OccEndpointsService,
  USE_CLIENT_TOKEN,
} from '@spartacus/core';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { GgFirmwareVerificationAdapter } from './gg-firmware-verification.adapter';
import { GGFirmwareWSDTO } from '../../components/gg-firmware-verification/gg-firmware-verification.component';

@Injectable({
  providedIn: 'root',
})
export class OccGgFirmwareVerificationAdapter implements GgFirmwareVerificationAdapter {
  protected logger = inject(LoggerService);

  constructor(
    private http: HttpClient,
    private occEndpoints: OccEndpointsService
  ) {}

  checkFirmware(extraId: string): Observable<GGFirmwareWSDTO[]> {
    const url = this.occEndpoints.buildUrl('firmwareVerification', {
      urlParams: { extraId: extraId },
    });

    let headers = new HttpHeaders();
    headers = InterceptorUtil.createHeader(USE_CLIENT_TOKEN, true, headers);

    return this.http
      .get<GGFirmwareWSDTO[]>(url, {
        headers: headers,
      })
      .pipe(catchError((error) => throwError(normalizeHttpError(error, this.logger))));
  }
}
